import { render, staticRenderFns } from "./ReceptionPendingView.vue?vue&type=template&id=79beea07&scoped=true"
import script from "./ReceptionPendingView.vue?vue&type=script&lang=js"
export * from "./ReceptionPendingView.vue?vue&type=script&lang=js"
import style0 from "./ReceptionPendingView.vue?vue&type=style&index=0&id=79beea07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79beea07",
  null
  
)

export default component.exports